import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Mail, Loader2 } from "lucide-react";

export default function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      if (data.already_subscribed) {
        toast.success("You're already on our list — thank you!");
      } else {
        toast.success("Subscribed. We'll write only when it matters.");
      }
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Could not subscribe");
    } finally {
      setLoading(false);
    }
  };
  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="flex gap-2">
      <div className="relative flex-1">
        <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-white/50" />
        <Input
          type="email"
          required
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="newsletter-email"
          className="pl-9 h-11 bg-white/5 border-white/15 text-white placeholder:text-white/40 focus-visible:ring-[#D4AF37]"
        />
      </div>
      <Button
        type="submit"
        disabled={loading}
        data-testid="newsletter-submit"
        className="rounded-full bg-[#D4AF37] text-[#0A2540] hover:bg-white h-11 px-5"
      >
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Subscribe"}
      </Button>
    </form>
  );
}
